import type {CopilotAnimationStateProps} from '../types'
import styles from './Static.module.css'

export default function CopilotAnimationStatic({scale = 1, state}: CopilotAnimationStateProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32 * scale}
      height={32 * scale}
      viewBox="0 0 32 32"
      className={styles.static}
      data-animation-state={state}
      fill="currentColor"
      aria-hidden
    >
      <path
        d="M24.4234,12.3467c0.3362,0.7559,0.7565,1.5491,0.9952,2.4495c0.1135,0.0555,0.2374,0.1299,0.3706,0.1789
	c0.8842,0.2974,1.3559,1.1355,1.9365,1.8026c0.1649,0.1994,0.2584,0.422,0.2678,0.6836c0.0413,1.1443,0.0624,2.2883,0.0029,3.4631
	c-0.6753,0.7723-1.449,1.4885-2.3765,1.9693c-3.1853,1.8194-6.8046,3.0855-10.5179,2.832c-3.285-0.2064-6.3894-1.461-9.1773-3.1601
	c-0.7035-0.4234-1.253-1.0217-1.8087-1.6122c-0.1135-1.2862-0.0529-2.5526,0.0189-3.8306c0.3847-0.5719,0.8017-1.1182,1.2948-1.597
	c0.2046-0.1987,0.4711-0.3372,0.7201-0.4851c0.141-0.0837,0.3036-0.1308,0.4825-0.2053C6.8,14.1966,7.089,13.5988,7.3427,12.9865
	c0.061-0.1471,0.0493-0.325,0.0672-0.4892c0.0539-0.4957,0.0858-0.9948,0.1633-1.4868c0.4092-2.2852,2.9859-3.047,4.9763-3.3911
	c0.2453-0.0431,0.4933-0.0819,0.7314-0.152c0.8436-0.2484,1.71-0.3751,2.5811-0.435c0.4507-0.031,0.9127,0.0487,1.3652,0.1108
	c0.6186,0.0849,1.2287,0.2162,1.8271,0.4023c0.2772,0.0862,0.5662,0.1347,0.8501,0.1992c1.8413,0.3699,4.0361,1.2775,4.3531,3.3627
	C24.3225,11.4967,24.3631,11.8903,24.4234,12.3467z M15.8919,14.1586c-0.0426,0.066-0.062,0.1308-0.0695,0.1618
	c-0.1831,0.7602-0.7055,1.2032-1.3938,1.4831c-1.2536,0.5223-2.305,0.6827-3.6581,0.464c-0.7066-0.0938-1.3877-0.2665-2.0016-0.6484
	C8.6851,15.567,8.591,15.5313,8.472,15.4736C8.3827,15.6471,8.3226,15.8214,8.2659,16c-0.1095,0.4798-0.1569,0.9623-0.2015,1.4359
	c-0.1387,1.4755-0.1276,2.949,0.2564,4.396c0.9351,0.8712,2.9937,1.4525,4.2539,1.6793c2.5378,0.5104,5.1618,0.4682,7.6677-0.1919
	c1.203-0.2951,2.3396-0.7659,3.3709-1.4657c0.4204-2.0163,0.3328-4.0708-0.0087-6.0888c-0.0525-0.1475-0.1015-0.24-0.2734-0.3328
	c-0.0687,0.0394-0.1607,0.0844-0.2443,0.1417c-0.7293,0.5211-1.6237,0.6161-2.4849,0.735
	c-1.2181,0.1849-2.3555-0.1068-3.4502-0.6074c-0.5734-0.2622-0.9848-0.6881-1.1545-1.3161
	C15.9834,14.3334,15.917,14.2115,15.8919,14.1586z M22.5311,11.9853c-0.0127-0.2285-0.0359-0.4571-0.0357-0.6856
	c0.0004-0.4685-0.2251-0.7932-0.6299-0.9945c-0.2972-0.1477-0.5982-0.3009-0.9145-0.3936
	c-0.8578-0.2411-1.7336-0.4754-2.6331-0.4328c-0.5807-0.0051-0.968,0.5502-0.9921,1.0879
	c-0.0273,0.7684-0.0533,1.5369,0.0271,2.3063c0.0809,0.7746,0.49,1.2587,1.214,1.4984c0.7991,0.2646,1.624,0.3614,2.4603,0.3329
	C22.3974,14.6943,22.5663,13.0471,22.5311,11.9853z M14.4839,11.6733c-0.0015,0-0.0031,0-0.0046,0
	c0-0.354,0.0163-0.709-0.0036-1.0619c-0.0446-0.9827-0.9257-1.2007-1.7562-1.0471c-0.5525,0.0996-1.1022,0.2194-1.6476,0.3531
	c-0.4265,0.1046-0.8221,0.2948-1.1985,0.5215c-0.2862,0.1723-0.4586,0.4217-0.4861,0.7575
	c-0.0976,0.9281-0.1167,1.8906,0.2578,2.7653c0.2175,0.5783,0.8094,0.7647,1.3858,0.7497c0.8479-0.0267,1.7193-0.1092,2.4985-0.4675
	C14.5481,13.8163,14.4949,12.6065,14.4839,11.6733z"
      />
      <path
        d="M18.0801,17.2702c0.613,0,0.884,0.4186,0.9043,1.0525c0.0186,0.5818,0.0107,1.1647,0.001,1.7469
	c0.0028,0.5809-0.3434,1.0967-0.9639,1.0498c-0.3573-0.0341-0.6566-0.2979-0.7439-0.6594
	c-0.0145-0.0602-0.0223-0.1234-0.0226-0.1853c-0.0031-0.7071-0.0137-1.4145-0.0018-2.1214
	C17.2531,17.6478,17.5713,17.2702,18.0801,17.2702z"
      />
      <path
        d="M14.4848,20.4914c0,0.4172-0.4046,0.6532-0.7945,0.6624c-0.6615-0.0026-0.9038-0.3537-0.9038-1.1018
	c-0.0176-0.5595-0.0267-1.1193-0.0327-1.679c-0.0013-0.1231,0.0084-0.2504,0.0389-0.369c0.2189-0.8966,1.5327-0.8795,1.6719,0.0652
	c0.0328,0.2029,0.0225,0.4132,0.0263,0.6202c0.0038,0.2073,0.0008,0.4147,0.0008,0.622
	C14.4974,19.3114,14.4848,20.1128,14.4848,20.4914z"
      />
    </svg>
  )
}
